import React from 'react'
import { withRouter } from 'react-router-dom'

import { Toast } from 'primereact/toast';
import { Dropdown } from 'primereact/dropdown'
import { InputText } from 'primereact/inputtext'
import { InputMask } from 'primereact/inputmask';
import { SelectButton } from 'primereact/selectbutton'
import { Button } from 'primereact/button';

import NavBar from '../../../src/componentes/Navbar'
import UsuarioService from '../../app/service/UsuarioService'
import EstadoService from '../../app/service/EstadoService'
import CidadeService from '../../app/service/CidadeService'
import PerfilService from '../../app/service/PerfilService'
import { AuthContext } from '../../main/ProvedorAutenticacao'

class EditarUsuario extends React.Component {

  constructor(props) {
    super(props)

    this.usuarioService = new UsuarioService();
    this.estadoService = new EstadoService();
    this.cidadeService = new CidadeService();
    this.perfilService = new PerfilService();

    this.options = ['Ativo', 'Inativo'];

    this.state = {
      //Edição de usuário
      codigo: '',
      nome: '',
      email: '',
      cpf: '',
      endereco: '',
      numero: '',
      cep: '',
      bairro: '',
      complemento: '',
      telefone1: '',
      telefone2: '',
      cidades: [],
      estados: [],
      estado: null,
      cidade: null,
      perfis: [],
      perfil: null,
      empresa: null,
      situacao: '',
      ligaSituacao: ''
    };
  }

  async componentDidMount() {
    const params = this.props.match.params;
    if(params.codigo) {
      await this.consultarUsuario(params.codigo);
      this.listarPerfis();
    }
  }

  listarPerfis = async () => {
    await this.perfilService.listarPerfis()
      .then(response => {
        this.setState({perfis: response.data})
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Perfis', detail:'Erro ao listar perfis', life: 4000});
      })
  }

  consultarUsuario = async (codigo) => {
    await this.usuarioService.consultarUsuario(codigo)
      .then(response => {
        this.setState({codigo: response.data.codigo});
        this.setState({nome: response.data.nome});
        this.setState({email: response.data.email});
        this.setState({cpf: response.data.cpf});
        this.setState({endereco: response.data.endereco});
        this.setState({numero: response.data.numero});
        this.setState({cep: response.data.cep});
        this.setState({bairro: response.data.bairro});
        this.setState({complemento: response.data.complemento});
        this.setState({telefone1: response.data.telefone1});
        this.setState({telefone1: response.data.telefone2});
        this.setState({estado: response.data.cidade.estado});
        this.setState({cidade: response.data.cidade});
        this.setState({perfil: response.data.perfil});
        if(response.data.situacao === 0) {
          this.setState({ligaSituacao: 'Ativo'});
        } else {
          this.setState({ligaSituacao: 'Inativo'});
        }
        this.setState({situacao: this.state.situacao});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Usuários', detail:`${this.state.detail}`, life: 4000});
      });

      this.listarEstados();
  }

  alterarUsuario = () => {
    if(this.state.nome == '') {
      this.toast.show({severity:'error', summary: 'Cadastro de Usuários', detail: 'Informe o nome do Usuário', life: 4000});
      return false;
    }

    if(this.state.email == '') {
      this.toast.show({severity:'error', summary: 'Cadastro de Usuários', detail: 'Informe o E-Mail do Usuário', life: 4000});
      return false;
    }

    if(this.state.cidade == null) {
      this.toast.show({severity:'error', summary: 'Cadastro de Usuários', detail: 'Informe a Cidade', life: 4000});
      return false;
    }

    if(this.state.perfil == null) {
      this.toast.show({severity:'error', summary: 'Cadastro de Usuários', detail: 'Informe o Perfil do Usuário', life: 4000});
      return false;
    }

    const usuarioLogado = this.context.usuarioAutenticado;

    this.usuarioService.alterarUsuario({
      codigo: this.state.codigo,
      nome: this.state.nome,
      email: this.state.email,
      cpf: this.state.cpf,
      endereco: this.state.endereco,
      numero: this.state.numero,
      cep: this.state.cep,
      bairro: this.state.bairro,
      complemento: this.state.complemento,
      cidade: this.state.cidade,
      telefone1: this.state.telefone1,
      telefone2: this.state.telefone2,
      perfil: this.state.perfil,
      empresa: usuarioLogado.empresa,
      situacao: this.state.ligaSituacao === 'Ativo' ? 0 : 1
    }).then(response => {
        this.toast.show({severity:'success', summary: 'Edição de Usuários', detail: 'Usuário alterado com sucesso', life: 4000});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Edição de Usuários', detail:`${this.state.detail}`, life: 4000});
      })
  }

  listarEstados = async () => {
    await this.estadoService.listarEstados()
      .then(response => {
        this.setState({estados: response.data});
      });

      this.listarCidades();
  }

  listarCidades = async () => {
    if(this.state.estado) {
      await this.cidadeService.listarCidades(this.state.estado.codigo)
        .then(response => {
          this.setState({cidades: response.data})
          console.log('Lista de Cidades', this.state.cidades)
        }).catch(error => {
          this.setState(error.response.data)
          this.toast.show({severity:'error', summary: 'Usuários', detail:`${this.state.detail}`, life: 4000});
        })
    }
  }

  voltar = () => {
    this.props.history.push('/usuarios')
  }

  render() {
    return(
      <>
        <NavBar/>
        <Toast ref={(el) => this.toast = el} />
        <div className="content-wrapper">
          <div className="container-fluid">
            <section className="content-header">
              <div className="card card-primary card-outline">
                <div className="card-header">
                  <h3 className="card-title">
                    <i className="fas fa-users"></i>
                    <span> Consulta de Usuários</span>
                  </h3>  
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-sm-6">
                      <div className="form-group">
                      <SelectButton value={this.state.ligaSituacao} 
                                    options={this.options} 
                                    onChange={(e) => this.setState({ ligaSituacao: e.value })} />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-6">
                      <div className="form-group">
                        <label>Nome<span className="obrigatorioAsterisco"> *</span></label>
                        <InputText id="nome" 
                                   type="text" 
                                   style={{width: '100%'}} 
                                   value={this.state.nome}
                                   onChange={e => this.setState({nome: e.target.value})}
                                   className="p-inputtext-sm p-d-block p-mb-1"/>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-4">
                      <div className="form-group">
                        <label>E-Mail<span className="obrigatorioAsterisco"> *</span></label>
                        <InputText id="email" 
                                   type="text" 
                                   style={{width: '100%'}} autoComplete="off" 
                                   value={this.state.email}
                                   onChange={e => this.setState({email: e.target.value})}
                                   className="p-inputtext-sm p-d-block p-mb-1"/>
                        
                      </div>
                    </div>
                    <div className="col-sm-2">
                      <div className="form-group">
                        <label>CPF</label>
                        <InputMask mask="999.999.999-99" 
                                   id="cpf" 
                                   type="text" 
                                   style={{width: '100%'}}
                                   value={this.state.cpf}
                                   onChange={e => this.setState({cpf: e.target.value})}
                                   className="p-inputtext-sm p-d-block p-mb-1"/>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-6">
                      <div className="form-group">
                        <label>Endereço</label>
                        <InputText id="endereco" 
                                   type="text" 
                                   style={{width: '100%'}} 
                                   autocomplete="off"
                                   value={this.state.endereco}
                                   onChange={e => this.setState({endereco: e.target.value})}
                                   className="p-inputtext-sm p-d-block p-mb-1"/>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-6">
                      <div className="form-group">
                        <label>Bairro</label>
                        <InputText id="bairro" 
                                   type="text" 
                                   style={{width: '100%'}}
                                   value={this.state.bairro}
                                   onChange={e => this.setState({bairro: e.target.value})}
                                   className="p-inputtext-sm p-d-block p-mb-1"/>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-1">
                      <div className="form-group">
                        <label>Número</label>
                        <InputText id="numero" 
                                   type="text" 
                                   style={{width: '100%'}}
                                   value={this.state.numero}
                                   onChange={e => this.setState({numero: e.target.value})}
                                   className="p-inputtext-sm p-d-block p-mb-1"/>
                      </div>
                    </div>
                    <div className="col-sm-2">
                      <div className="form-group">
                        <label>Cep</label>
                        <InputMask mask="99999-999" 
                                   id="cep" 
                                   type="text" 
                                   style={{width: '100%'}}
                                   value={this.state.cep}
                                   onChange={e => this.setState({cep: e.target.value})}
                                   className="p-inputtext-sm p-d-block p-mb-1"/>
                      </div>
                    </div>
                    <div className="col-sm-3">
                      <div className="form-group">
                        <label>Complemento</label>
                        <InputText id="complemento" 
                                   type="text" 
                                   style={{width: '100%'}}
                                   value={this.state.complemento}
                                   onChange={e => this.setState({complemento: e.target.value})}
                                   className="p-inputtext-sm p-d-block p-mb-1"/>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-3">
                      <div className="form-group">
                        <label>Estado<span className="obrigatorioAsterisco"> *</span></label>
                        <Dropdown value={this.state.estado} 
                            options={this.state.estados} style={{width: '100%'}}
                            optionLabel="estado" 
                            filter showClear filterBy="estado"
                            onChange={this.onEstadoChange}
                            id="estado"
                            className="p-inputtext-sm p-d-block p-mb-1"/>
                      </div>
                    </div>
                    <div className="col-sm-3">
                      <div className="form-group">
                        <label>Cidade<span className="obrigatorioAsterisco"> *</span></label>
                        <Dropdown value={this.state.cidade} options={this.state.cidades} style={{width: '100%'}}
                            optionLabel="nome" emptyMessage="Nenhuma cidade para este estado"
                            filter showClear filterBy="nome"
                            onChange={this.onCidadeChange}
                            id="cidade"
                            className="p-inputtext-sm p-d-block p-mb-1"/>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-3">
                      <div className="form-group">
                        <label>Telefone 1</label>
                        <InputMask mask="(99)9 9999-9999" 
                                   id="telefone1" 
                                   type="text" 
                                   style={{width: '100%'}}
                                   value={this.state.telefone1}
                                   onChange={e => this.setState({telefone1: e.target.value})}
                                   className="p-inputtext-sm p-d-block p-mb-1"/>
                      </div>
                    </div>
                    <div className="col-sm-3">
                      <div className="form-group">
                        <label>Telefone 2</label>
                        <InputMask mask="(99)9999-9999" 
                                   id="telefone2" 
                                   type="text" 
                                   style={{width: '100%'}}
                                   value={this.state.telefone2}
                                   onChange={e => this.setState({telefone2: e.target.value})}
                                   className="p-inputtext-sm p-d-block p-mb-1"/>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-6">
                      <div className="form-group">
                        <label>Perfil<span className="obrigatorioAsterisco"> *</span></label>
                        <Dropdown value={this.state.perfil} 
                            options={this.state.perfis} style={{width: '100%'}}
                            optionLabel="nome" 
                            filter showClear filterBy="nome"
                            onChange={e => this.setState({perfil: e.target.value})}
                            id="perfil"
                            className="p-inputtext-sm p-d-block p-mb-1"/>
                      </div>
                    </div>
                  </div>
                </div>
                <div style={{paddingLeft: '20px'}}>
                  <Button label="Alterar" 
                          className="p-button-primary p-button-text"
                          onClick={this.alterarUsuario}/>
                  
                  &nbsp;
                  <Button label="Voltar" 
                          className="p-button-secondary p-button-text"
                          onClick={this.voltar}/>
                </div>
              </div>
             </section>
            </div>
          </div>
      </>
    );
  }
}
EditarUsuario.contextType = AuthContext;
export default withRouter (EditarUsuario);